"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.JUSTIFY_FLEX_CLASSES = exports.BG_COLOR = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.offer"));

var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.image"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");

require("./Offers.scss");

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.constants");

var _secondaryOfferUtils = require("./secondaryOfferUtils");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const JUSTIFY_FLEX_CLASSES = {
  SPACE_BETWEEN: 'spaceBetween',
  SPACE_EVENLY: 'spaceEvenly',
  FLEX_START: 'flexStart',
  FLEX_END: 'flexEnd'
};
exports.JUSTIFY_FLEX_CLASSES = JUSTIFY_FLEX_CLASSES;
const BG_COLOR = {
  GREY_1: 'grey1',
  GREY_8: 'grey8',
  GREY_7: 'grey7'
}; // indica cuántas ofertas se muestran en pantalla según el dispositivo.

exports.BG_COLOR = BG_COLOR;
const MAX_OFFERS_SCREEN = {
  pc: 3,
  tablet: 3,
  mobile: 1
};

class SecondaryOfer extends _react.Component {
  constructor(props) {
    super(props); // Número de ofertas que se van a mostrar.

    _defineProperty(this, "checkDataInput", () => {
      const {
        offerHome,
        offersNumber
      } = this.state;
      let trues = 0;
      let falses = 0;
      const {
        items
      } = offerHome;

      if (items && Array.isArray(items) && items.length === offersNumber) {
        for (let i = 0; i < items.length; i += 1) {
          if (typeof items[i].marked !== 'undefined') {
            if (items[i].marked) {
              trues += 1;
            } else {
              falses += 1;
            }
          }
        }
      }

      return {
        trues,
        falses,
        items
      };
    });

    const {
      offersNumber: _offersNumber,
      isCaroussel
    } = props;
    this.state = {
      offerHome: props,
      offersNumber: _offersNumber,
      isCaroussel
    };
  }

  render() {
    const {
      offerHome,
      offersNumber,
      isCaroussel
    } = this.state;
    const {
      containerFlexMode,
      offersFullWidth,
      equalizedHeight,
      bgColor,
      bgImage
    } = this.props;

    if (!offerHome) {
      return null;
    }

    let offerMaxWidthClass = '';

    if (offersFullWidth) {
      offerMaxWidthClass = 'ampliated';
    }

    let offerHeightClass = '';

    if (equalizedHeight) {
      offerHeightClass = 'equalizedHeight';
    }

    const device = (0, _gerenciatdUtils.getDeviceKindDependsOnViewPort)();
    const {
      trues,
      falses,
      items
    } = this.checkDataInput();
    const {
      components
    } = offerHome;
    const sliderSettings = {
      dots: device !== _gerenciatdUtils2.DEVICES.MOBILE,
      infinite: false,
      speed: 500,
      slidesToShow: device === _gerenciatdUtils2.DEVICES.MOBILE ? 1.18 : 3,
      slidesToScroll: 1,
      arrows: true
    };
    const idSecondaryOffer = `secondaryOffer${(0, _secondaryOfferUtils.giveRandomNumber)(0, 1000)}`;
    bgImage ? (0, _secondaryOfferUtils.generateBgSecondaryOffer)(idSecondaryOffer, bgImage) : '';

    if ((trues + falses === offersNumber || trues + falses === 0) && items) {
      let classContainer = '';

      if (trues > 0) {
        classContainer = 'highlighted';
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
        id: idSecondaryOffer,
        className: `secondaryOffer ${bgImage ? '' : `secondaryOffer_bgColor--${bgColor}`}`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "placer container",
          children: [components && components['TextInfo-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, components['TextInfo-1']), {}, {
            className: "mainTitle"
          })), components && components['TitleImage'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, _objectSpread(_objectSpread({}, components['TitleImage']), {}, {
            className: "secondaryOffer__titleImage"
          })), isCaroussel && offersNumber > MAX_OFFERS_SCREEN[device] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSlick.default, _objectSpread(_objectSpread({}, sliderSettings), {}, {
            children: items.map((offerItem, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread({
              className: `${offerHeightClass}`
            }, offerItem), `offer_container_${index.toString()}`))
          })), !isCaroussel && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: `OffersContainer ${classContainer} ${containerFlexMode}`,
            children: items.map((offerItem, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread({
              className: offerMaxWidthClass
            }, offerItem), `offer_container_${index.toString()}`))
          })]
        })
      });
    }

    return null;
  }

} // eslint-disable-next-line react/display-name


SecondaryOfer.WaitingComponent = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
  className: "configFake secondaryOffer",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
    count: 1,
    height: 30,
    width: "50%"
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "container",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
      count: 1,
      height: 180,
      width: "100%"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
      count: 1,
      height: 180,
      width: 200
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
      count: 1,
      height: 180,
      width: 200
    })]
  })]
});

SecondaryOfer.propTypes = {
  offersNumber: _propTypes.default.number,
  isCaroussel: _propTypes.default.bool.isRequired,
  containerFlexMode: _propTypes.default.oneOf([JUSTIFY_FLEX_CLASSES.FLEX_END, JUSTIFY_FLEX_CLASSES.FLEX_START, JUSTIFY_FLEX_CLASSES.SPACE_BETWEEN, JUSTIFY_FLEX_CLASSES.SPACE_EVENLY]),
  equalizedHeight: _propTypes.default.bool.isRequired,
  offersFullWidth: _propTypes.default.bool.isRequired,
  // Indica si los hijos deben ocupar el máximo o dejar hueco entre ellos.
  bgColor: _propTypes.default.oneOf([BG_COLOR.GREY_1, BG_COLOR.GREY_8, BG_COLOR.GREY_7]),
  bgImage: _propTypes.default.string.isRequired
};
SecondaryOfer.defaultProps = {
  offersNumber: 3,
  isCaroussel: false,
  containerFlexMode: JUSTIFY_FLEX_CLASSES.SPACE_BETWEEN,
  offersFullWidth: false,
  equalizedHeight: true,
  bgColor: BG_COLOR.GREY_1,
  bgImage: ''
};
var _default = SecondaryOfer;
exports.default = _default;

//# sourceMappingURL=index.js.map